import { useCallback, useEffect, useState } from "react";

import { Link, useHistory } from "react-router-dom";

import CustomInput from "../../components/CustomInput";
import DefaultButton from "../../components/DefaultButton";
import Dialog from "../../components/Dialog";

import { useAuth } from "../../contexts/auth";
import { GetToken } from "../../services/auth";
import {
  GloboIcon,
  StyledCard,
  StyledContainer,
  StyledForm,
  StyledGrid,
  MediaproIcon,
} from "./styles";

import GloboLogo from "../../assets/globo-logo.png";
import MediaproLogo from "../../assets/adchecking-mediapro.svg";
import { useDialog } from "../../contexts/dialog";
import axios from "../../services/api";
import {
  FontFamilyByCurrentApp,
  isGloboCurrentApp,
  LinkColorByCurrentApp,
} from "../../utils/get-app-env";
import { UsersProps } from "../admin/types";
import { UserProp } from "./types";
import { Grid } from "@material-ui/core";

const LoginPage = () => {
  const Auth = useAuth();
  const fontFamily = FontFamilyByCurrentApp();
  const [user, setUser] = useState<UserProp>({
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  const memoizedDisabledButtonHandler = useCallback(() => {
    const { username, password } = user;
    if (username && password) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [user]);
  const dialog = useDialog();
  const history = useHistory();

  const handleUserChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;

    setUser({ ...user, [name]: value });
  };

  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleGetToken = async () => {
    const responseToken = await GetToken(user);

    try {
      const { data } = await axios.get<UsersProps>(`/users/${user?.username}`, {
        headers: {
          Authorization: "Bearer " + responseToken?.token,
        },
      });

      if (responseToken) {
        Auth.setSessionData({
          username: user.username,
          role: data?.role,
          rendering: data?.rendering,
          groups: data.groups,
          ...responseToken,
        });
        Auth.setIsLoggedOut(false);
        handleGetUserDefaultRoute(data?.rendering);
      } else {
        dialog.setDialogStatus(true);
      }
    } catch (err) {
      console.log(err);
      dialog.setDialogStatus(true);
    }
  };

  const handleGetUserDefaultRoute = async (rendering: string = "VIDEO") => {
    switch (rendering) {
      case "VIDEO":
        history.push("/video");
        return;
      case "AUDIO":
        history.push("/audio");
        return;
      case "SIMULCAST":
        history.push("/simulcast");
        return;
      default:
        history.push("/video");
        return;
    }
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    handleGetToken();
  };

  useEffect(() => {
    memoizedDisabledButtonHandler();
  }, [memoizedDisabledButtonHandler, user]);

  return (
    <StyledContainer maxWidth="md">
      <StyledGrid container justifyContent="center">
        <StyledForm onSubmit={handleSubmit}>
          <StyledCard>
            {isGloboCurrentApp() ? (
              <GloboIcon src={GloboLogo} alt="logo Globo" />
            ) : (
              <MediaproIcon src={MediaproLogo} alt="logo Mediapro" />
            )}
            <StyledGrid
              item
              lg={7}
              md={7}
              sm={8}
              xs={11}
              style={{ marginTop: "110px" }}
            >
              <CustomInput
                label="Username"
                name="username"
                id="outlined-username"
                value={user.username}
                handleChange={handleUserChange}
              />

              <CustomInput
                isPassword
                label="Password"
                name="password"
                id="outlined-adornment-password"
                value={user.password}
                showPassword={showPassword}
                handleChange={handleUserChange}
                handleClickShowPassword={handleClickShowPassword}
              />
              <Grid
                container
                style={{
                  marginTop: 8,
                  marginBottom: 16,
                  justifyContent: "flex-end",
                  textDecoration: "underline",
                }}
              >
                <Link to="/forgot-password" style={{ fontFamily, color: LinkColorByCurrentApp() }}>
                  Esqueceu sua senha?
                </Link>
              </Grid>
              <DefaultButton
                typecolor="blueButton"
                variant="contained"
                type="submit"
                disableRipple
                text="Entrar"
                disabled={disabledButton}
              />

              <Dialog
                openDialog={true}
                setOpenDialog={dialog.setDialogStatus}
                dialogText="Usuário ou senha invalido(s). Tente novamente."
              />
            </StyledGrid>
          </StyledCard>
        </StyledForm>
      </StyledGrid>
    </StyledContainer>
  );
};

export default LoginPage;
